export default __webpack_public_path__ + "static/media/transition.e3873ea7.png";